'use client'
import React from 'react'
import { Box, Grid } from '@mui/material'
import DynamicForm, { FieldConfig } from '@/components/DynamicForm/DynamicForm'
import { validateName, validateTelephoneNumber } from '@/utils/ContactUs/validations'
import OpeningHours from '@/components/OpeningHours/OpeningHours'

const nameCol: FieldConfig[] = [{ name: 'name', label: 'Your name', validate: validateName }]

const phoneCol: FieldConfig[] = [
  {
    name: 'telephoneNumber',
    label: 'Phone number',
    type: 'tel',
    validate: validateTelephoneNumber
  }
]

const checkboxCol: FieldConfig[] = [
  {
    name: 'alreadyApplied',
    label: 'Tick this box if you have already applied',
    fieldType: 'checkbox'
  }
]

const CallbackFooter = () => (
  <Box component="section" sx={{ py: { xs: 5, md: 6 } }}>
    <Grid container spacing={5} alignItems="center">
      <Grid item xs={12} mdplus>
        <DynamicForm
          fieldsLeftCol={nameCol}
          fieldsRightCol={phoneCol}
          fields100Col={checkboxCol}
          emailType="CallRequest"
          submitTxt="Call me back"
          isInline
        />
      </Grid>
      <Grid item xs={12} mdplus="auto">
        <OpeningHours />
      </Grid>
    </Grid>
  </Box>
)

export default CallbackFooter
